import { CompetitorsService } from "src/app/services/competitors.service";
import { TextCol } from "../../records/models/columns/text-col";
import { MeUser } from "src/app/services/models/me-user";
import { TableStructure } from "../../records/models/table-structure";
import { ActionCol } from "src/app/shared/table-col-configs/action-col";
import { ActionButtonsComponent } from "src/app/shared/table-components/action-buttons/action-buttons.component";
import { Type } from "@angular/core";
import { DeleteCommand } from "../../records/commands/delete-command";
import { ConfirmDialogComponent } from "src/app/shared/dialogs/confirm-dialog/confirm-dialog.component";
import { DELETE_RECOVERY_PLAN_DIALOG_CONFIG } from "src/app/services/delete-recovery-plan-dialog-config";
import { DELETE_COMPETITORS_DIALOG_CONFIG } from "src/app/services/delete-competitors-dialog.config";
import { CreateCommand } from "src/app/shared/commands/create-command";
import { Competitors } from "../hot-alert/configurations/competitors";

export const genCompetitorsTableConfig = (service: CompetitorsService, user: MeUser | null) => {
    
    const COMPETITORS_TABLE_CONFIG: TableStructure<Competitors> = new TableStructure<Competitors>(
      [
      new TextCol("dealerId", false, "competitors.dealerId", undefined, true),
      new TextCol("businessId", false, "competitors.businessId", undefined, true),
      new TextCol("competitors_businessId", undefined, 'competitors.competitors_businessId'),
      new TextCol("competitorsName", undefined, 'competitors.competitorsName'),
      new TextCol("phone", undefined, "competitors.phone"),
      new TextCol("zip", undefined, "competitors.zip"),
      new ActionCol<Competitors, Type<ActionButtonsComponent<Competitors>>, CompetitorsService>(
        "deleteAction",
        false,
        "delete",
        [
          new DeleteCommand<Competitors, CompetitorsService>(
            service,
            ConfirmDialogComponent,
            DELETE_COMPETITORS_DIALOG_CONFIG
          ),
        ],
        ActionButtonsComponent
      ),
      ],
        "serverSide",
        [10,20,30],
        undefined,
        true,
        [
          new CreateCommand<Competitors, CompetitorsService>(service),
        ],
        undefined,
        true
      );
    
      return COMPETITORS_TABLE_CONFIG;
    };